<template>
  <div class="perf-chart-wrapper" style="height: 100%;" >
    <p class="perf-status">
      <span :style="{lineHeight: '16px', fontSize: (convertStatusValue.length >= 15) ? '14px' : '16px'}">
        {{ convertStatusValue }}
      </span>
    </p>
    <w-common-chart style="height: 50%; width: 100%;" ref="chart" :chart-type="'LINE'"/>
    <div class="perf-label">
      <p><label :title="label">{{ label }}</label></p>
    </div>
  </div>
</template>

<script>
import WCommonChart from '@/views/topologymap/components/major-info/components/CommonChart';

import { find, isEmpty, isNaN, isNil } from 'lodash';
import { convertValuByUnit } from '@/utils/number';

export default {
  name: 'WPerfChartView',
  components: {
    WCommonChart,
  },
  props: {
    /**
     * 차트 데이터
     * @type {Object}
     */
    chartData: {
      type: Object,
      default: () => {},
    },
    /**
     * 차트 라벨 데이터
     * @type {Object}
     */
    nameList: {
      type: Array,
      default: () => ([]),
    },
    /**
     * 데이터와 라벨을 표현하기위한 차트 index값
     * @type {Object}
     */
    idx: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      perfKey: null,
      /**
       * 이력 성능 데이터
       * @type {Array}
       */
      histList: [],
      /**
       * 현재 성능 데이터
       * @type {Object}
       */
      status: {},
    };
  },
  computed: {
    /**
     * 차트 라벨 데이터에서 해당하는 index의 라벨 반환
     * @author JungJiyoon(ryunnnne)
     * @return {[type]} [description]
     */
    label() {
      let label = '';
      label = this.nameList[this.idx];
      return label;
    },
    /**
     * 현재 성능 값 변환
     * @author JungJiyoon(ryunnnne)
     * @return {[type]} [description]
     */
    convertStatusValue() {
      let status = '';
      const vm = this;
      if (!isEmpty(this.status)) {
        if (!isEmpty(this.perfKey)) {
          if (this.perfKey === 'RESPONSETIME_TOTAL') {
            Object.keys(this.status).forEach((hashkeyId, idx) => {
              const info = find(vm.histList, (item) => item.rscInfo.hashkeyIdString === hashkeyId.toString());
              if (!isEmpty(info)) {
                status += (idx > 0) ? '/' : '';
                status += convertValuByUnit(Number(vm.status[hashkeyId]), info.rscUnit, false, null, true);
              }
            });
          } else {
            status = (isNil(this.status.value) || !isNaN(this.status.value)) ? '-' : convertValuByUnit(Number(this.status.value), this.status.rscUnit, false, null, true);
          }
        } else {
          Object.keys(this.status).forEach((hashkeyId, idx) => {
            const info = find(vm.histList, (item) => item.rscInfo.hashkeyIdString === hashkeyId.toString());
            if (!isEmpty(info)) {
              status += (idx > 0) ? '/' : '';
              status += convertValuByUnit(Number(vm.status[hashkeyId]), info.rscUnit, false, null, true);
            }
          });
        }
      } else {
        status = '-';
      }
      return status;
    },
  },
  watch: {
    chartData: {
      immediate: true,
      handler(data) {
        if (!isEmpty(data)) {
          this.setData();
        }
      },
    },
  },
  methods: {
    /**
     * 데이터 초기화 (요청데이터)
     * @author JungJiyoon(ryunnnne)
     */
    setData() {
      this.$nextTick(() => {
        if (!isEmpty(this.chartData.key)) {
          this.perfKey = this.chartData.key;
          this.histList = this.chartData.hist;
          this.status = (this.chartData.key === 'RESPONSETIME_TOTAL') ? this.chartData.status : this.chartData.status[0];
          if (!isEmpty(this.$refs.chart)) {
            this.$refs.chart.setData(this.chartData.hist);
          }
        } else {
          this.histList = this.chartData.hist;
          this.status = this.chartData.status;
          if (!isEmpty(this.$refs.chart)) {
            this.$refs.chart.setData(this.chartData.hist);
          }
        }
      });
    },
  },
};
</script>
<style lang="scss">
.perf-chart-wrapper {
  .perf-label,
  .perf-status {
    width: 100%;
    text-align: center;
  }
  .perf-status {
    display: grid;
    color: #4D90FA;
    font-size: 14px;
  }
  .perf-label {
    font-size: 12px;
    line-height: 12px;
    color: #666;
    span {
      padding: 3px 10px;
      background-color: #EEEEEE;
      border-radius: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/major-info/components/PerfView.vue